import React, {FunctionComponent, HTMLAttributes} from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

import {Styles, styles} from './MainNavRight.style';

export interface MainNavRightProps extends Styles, HTMLAttributes<HTMLDivElement> {}
const MainNavRight: FunctionComponent<MainNavRightProps> = ({
  classes,
  className,
  children,
  ...otherProps
}) => (
  <div className={classNames(classes.root, className)} {...otherProps}>
    {children}
  </div>
);

export default withStyles(styles)(MainNavRight);
